// extracted by mini-css-extract-plugin
module.exports = {"className":"srOnly_className__yhXZV"};